"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { resolveWaveParticipationVariant, type WaveParticipationVariant } from "@/helpers/waves/wave-participation-presentation.helpers";
import MemeParticipationDrop from "@/components/memes/drops/MemeParticipationDrop";
import { DefaultSingleWaveDrop } from "@/components/waves/drop/DefaultSingleWaveDrop";
import { MemesSingleWaveDrop } from "@/components/waves/drop/MemesSingleWaveDrop";
import { QuorumSingleWaveDrop } from "@/components/waves/drop/QuorumSingleWaveDrop";
import QuorumParticipationDrop from "@/components/waves/quorum/QuorumParticipationDrop";
import DefaultParticipationDrop from "./DefaultParticipationDrop";
import type { ResolvedWaveParticipationRendererSet, WaveParticipationRendererSet } from "./participationRenderer.types";

// Use this for one-off waves that should opt into a custom renderer before
// the API exposes a presentation variant.
const WAVE_PARTICIPATION_VARIANT_OVERRIDES: Readonly<Partial<Record<string, WaveParticipationVariant>>> = {};
const WAVE_PARTICIPATION_RENDERERS: Readonly<Record<WaveParticipationVariant, WaveParticipationRendererSet>> = {
  default: {
    ParticipationDrop: DefaultParticipationDrop,
    SingleWaveDrop: DefaultSingleWaveDrop
  },
  memes: {
    ParticipationDrop: MemeParticipationDrop,
    SingleWaveDrop: MemesSingleWaveDrop
  },
  curation: {
    ParticipationDrop: DefaultParticipationDrop,
    SingleWaveDrop: DefaultSingleWaveDrop
  },
  quorum: {
    ParticipationDrop: QuorumParticipationDrop,
    SingleWaveDrop: QuorumSingleWaveDrop
  }
};
export const useWaveParticipationRendererSet = waveId => {
  const $ = _c(8);
  const {
    isMemesWave,
    isCurationWave,
    isQuorumWave
  } = useSeizeSettings();
  let t0;
  if ($[0] !== isCurationWave || $[1] !== isMemesWave || $[2] !== isQuorumWave || $[3] !== waveId) {
    t0 = resolveWaveParticipationVariant({
      waveId,
      overrides: WAVE_PARTICIPATION_VARIANT_OVERRIDES,
      isMemesWave,
      isCurationWave,
      isQuorumWave
    });
    $[0] = isCurationWave;
    $[1] = isMemesWave;
    $[2] = isQuorumWave;
    $[3] = waveId;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const variant = t0;
  const t1 = WAVE_PARTICIPATION_RENDERERS[variant];
  let t2;
  if ($[5] !== t1 || $[6] !== variant) {
    t2 = {
      variant,
      ...t1
    };
    $[5] = t1;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};